<template>
    <div class="container">
        <div @click="selTime" class="selTimeBox">
            <!-- <div>{{ showStartTime }}</div> -->
            <!-- <div> -->
                {{ showEndTime }}
            <!-- </div> -->
        </div>
        
        <div class="timeLine">
            <TimeLine ref="Timeline2" :startTimes="startTime" :endTimes="endTime" :initTime="time2" :isMobile="true" @timeChange="timeChange2" :timeSegments="timeSegments"
                @click_timeSegments="click_timeSegments" @click_timeline="onClickTimeLine"  @dragTimeChange="onDragTimeChange"></TimeLine>
        </div>
        <div class="timeShow">{{ showTime2 }}</div>
        <van-popup position="bottom" v-model="show">
            <van-datetime-picker @confirm="confirmTime" @cancel="cancelTime"
            v-model="currentDate"
            title="选择时间"
            :max-date="maxDate"
            type="datetime"/>
        </van-popup>
    </div>
</template>
  
<script>
import dayjs from 'dayjs'

export default {
    props:{
        segments: {
          type: Boolean,
          default: true
        }
    },
    data() {
        return {
            // 显示时间段
            time2: '',
            maxDate: new Date(2025, 9, 1),
            timeSegments: [
                {
                    name: '时间段1',
                    beginTime:'',
                    endTime: '',
                    color: '#52b757',
                    startRatio: 0.65,
                    endRatio: 0.9
                }
            ],
            timer: null,
            show: false,
            currentDate: new Date(),
            startTime: '',
            endTime: '',
        }
    },
    computed: {
        // 显示时间段
        showTime2() {
            return dayjs(this.time2).format('YYYY-MM-DD HH:mm:ss')
        },
        showEndTime() {
            return dayjs(this.endTime).format('YYYY-MM-DD HH:mm:ss')
        },
        showStartTime() {
            return dayjs(this.startTime).format('YYYY-MM-DD HH:mm:ss')
        }
    },
    watch: {
        segments: {
        deep: true,
        handler: 'reRender'
        }
    },
    mounted() {
        this.initTimes()
    },
    beforeDestroy () {
        clearInterval(this.timer)  
        this.timer = null
    },
    methods: {
        initTimes() {
            this.endTime = new Date().getTime();
            this.startTime = new Date().getTime() - 2 * 60 * 60 * 1000
            this.time2 = new Date().getTime() - 2 * 60 * 60 * 1000
            console.log('time2',this.time2)
            this.getDate()
        },
        startSetInterval(time) {
            this.time2 = time
        },
        reRender(e) {
            this.$nextTick(() => {
            if (e) {
                this.timeSegments[0].beginTime = this.startTime
                this.timeSegments[0].endTime = this.endTime
            } else {
                this.timeSegments[0].beginTime = ''
                this.timeSegments[0].endTime = ''
                clearInterval(this.timer)  
            }
            })
        },
        getCheck(e) {
            this.reRender(e)
        },
        getDate() {
            const now = new Date();
            // 获取年月日
            const year = now.getFullYear(); 
            const month = now.getMonth();  
            const day = now.getDate();   
            // 获取时分秒
            const hours = now.getHours();         // 时（0-23）
            const minutes = now.getMinutes();     // 分（0-59）
            const seconds = now.getSeconds();     // 秒（0-59）
            this.maxDate = new Date(year, month, day,hours,minutes)
        }, 
        confirmTime(e) {
            this.currentDate = new Date(e).getTime()
            this.endTime = new Date(e).getTime();
            this.startTime = new Date(e).getTime() - 2 * 60 * 60 * 1000
            this.time2 = this.startTime
            this.timeSegments[0].beginTime = this.startTime
            this.timeSegments[0].endTime = this.endTime
            this.show = false
            this.$emit('setTime',this.timeSegments)
        },
        cancelTime() {
            this.show = false
        },
        selTime() {
            this.show = true;
        },
        // 显示时间段
        timeChange2(t) {
            this.time2 = t 
            this.$emit('dragTime',t)
        },
        click_timeSegments(arr, ...args) {
            console.log('onClickTimeSegments', arr, args)
            alert('点击了：' + arr[0].name)
        },
        onClickTimeLine(...args) {
            // console.log('onClickTimeLine1111', args)
        },
        onDragTimeChange(...args) {
            this.$emit('dragTime',args)
        }
    }
}
</script>
  
<style lang="less" scoped>
.container {
    // width: 390px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    position: relative;
    justify-content: center;
    flex-direction: column;
    .timeLine {
        height: 50px;
    }
}
.selTimeBox {
    font-size: 1rem;
    // display: flex;
    // justify-content: space-between;
    padding: 0px 1rem;
    padding-top: 1rem;
    // align-items: center;
    text-align: center;
    margin-bottom: 0.1rem;
}
.timeShow {
    margin: 10px 0;
    display: flex;
    justify-content: center;
    user-select: none;
    font-size: 1rem;
}
</style>